import React from 'react';
import useCustomNavigate from '../../../hooks/useCustomNavigate';
import { useSelector } from 'react-redux';

const NavigationMenu = ({ categories = [], onItemClick, parentCategory }) => {

  const currentLocationDetails = useSelector((state) => state?.counter?.location)

  const { goToNewTab,goTo } = useCustomNavigate()



  // Function to encode the location details as a query string
  const encodeLocationDetails = () => {
    const locationData = {
      city: currentLocationDetails.city || '',
      state: currentLocationDetails.state || '',
      country: currentLocationDetails.country || ''
    };
    return encodeURIComponent(JSON.stringify(locationData)); // Encoding the location object
  };


  return (
    <div className="bg-white shadow-md rounded   border-b-2 border-l-2 border-r-2 border-gray-400">
      <div className="py-4 px-3">
        <div className="flex justify-between">
          {categories.map((category, idx) => (
            <div key={idx} className="space-y-1 px-4">
              {category?.name && <h3 className="font-medium text-gray-700 border-b border-gray-400 py-1 whitespace-nowrap">{category.name}</h3>}
              <ul className="space-y-1 py-2">
                {category.items.map((item, index) => (
                  <li key={index} className="text-gray-600 bg-white  hover:text-red-500 cursor-pointer whitespace-nowrap"


                    // onClick={() => (onItemClick ? onItemClick() : goToNewTab(`/searchresult/${item.replace(/ /g, '-')}`))}

                    onClick={() => {
                      // Encode the location details and append it to the URL query string
                      const locationQuery = encodeLocationDetails();
                      const parentQuery = parentCategory ? `&parentCategory=${parentCategory}` : '';
                      if (item.url) {
                        goToNewTab(item.url, "_blank");
                      } else if (onItemClick) {
                        onItemClick();
                      }
                      else if(item.onItemClick){
                        item.onItemClick()
                      }
                      else {
                        goToNewTab(`/searchresult/bycategory?category=${item.replace(/ /g, '-')}&location=${locationQuery}${parentQuery}`);
                      }
                    }}


                  >{item?.name ? item.name : item}

                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NavigationMenu;
